import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editForm", "nameInput", "spinner", "submitBtn"]
  static values = { deleteUrl: String }

  edit(event) {
    event.preventDefault()
    event.stopPropagation()
    this.displayTarget.classList.add("hidden")
    this.editFormTarget.classList.remove("hidden")
    this.nameInputTarget.focus()
    this.nameInputTarget.select()
    this.element.draggable = false
  }

  cancel(event) {
    event.preventDefault()
    this.editFormTarget.classList.add("hidden")
    this.displayTarget.classList.remove("hidden")
    this.element.draggable = true
  }

  submitStart() {
    this.submitBtnTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
  }

  async confirmDelete(event) {
    event.preventDefault()
    event.stopPropagation()

    const url = event.currentTarget.dataset.pantryCardDeleteUrlValue
    const csrfToken = document.querySelector("meta[name='csrf-token']").content

    this.showLoader()

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": csrfToken
      }
    })

    if (response.ok) {
      const html = await response.text()
      Turbo.renderStreamMessage(html)
    } else {
      this.hideLoader()
    }
  }

  showLoader() {
    const container = document.getElementById("modal-container")
    if (container) {
      container.innerHTML = `
        <div class="fixed inset-0 z-[100] flex items-center justify-center">
          <div class="absolute inset-0 bg-ink/90 backdrop-blur-md"></div>
          <div class="relative flex items-center gap-4">
            <div class="w-5 h-5 border-2 border-terracotta border-t-transparent rounded-full animate-spin"></div>
            <span class="font-mono text-sm text-cream/60">Cargando...</span>
          </div>
        </div>
      `
    }
  }

  hideLoader() {
    const container = document.getElementById("modal-container")
    if (container) {
      container.innerHTML = ""
    }
  }
}
